var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOldCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8171 18.0891V15.1884H5.00464C3.24423 15.1884 1.81714 16.4871 1.81714 18.0891M6.91714 20.9899H15.4171C16.6073 20.9899 17.2023 20.9899 17.6569 20.7791C18.0567 20.5937 18.3818 20.2979 18.5855 19.934C18.8171 19.5203 18.8171 18.9788 18.8171 17.8958V4.74583C18.8171 3.6628 18.8171 3.12128 18.5855 2.70761C18.3818 2.34374 18.0567 2.04791 17.6569 1.86251C17.2023 1.65173 16.6073 1.65173 15.4171 1.65173H6.91714C5.13197 1.65173 4.23939 1.65173 3.55754 1.96789C2.95778 2.24599 2.47015 2.68975 2.16456 3.23555C1.81714 3.85605 1.81714 4.66833 1.81714 6.29288V16.3487C1.81714 17.9733 1.81714 18.7855 2.16456 19.406C2.47015 19.9518 2.95778 20.3956 3.55754 20.6737C4.23939 20.9899 5.13197 20.9899 6.91714 20.9899Z",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOldCourse);
export default __webpack_public_path__ + "static/media/menu_old_course.993cedaac1ed45e57cf11b74b2ded906.svg";
export { ForwardRef as ReactComponent };